module.exports = __webpack_public_path__ + "img/word.28e5ccdc.png";